/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.209.1-v202610071147-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export interface FormulaErrorOutputV1 {
    /**
     * The column of the formula that resulted in an error
     */
    "column"?: number;
    /**
     * The category of the formula error, i.e. when it was encountered
     */
    "errorCategory"?: ErrorCategoryEnum;
    /**
     * The type of formula error that occurred
     */
    "errorType"?: ErrorTypeEnum;
    /**
     * The line of the formula that resulted in an error
     */
    "line"?: number;
    /**
     * An error message for the compiled formula
     */
    "message"?: string;
    /**
     * A plain language status message with information about any issues that may have been encountered during an operation. Null if the status message has not been set.
     */
    "statusMessage"?: string;
}

export const ErrorCategoryEnum = {
    SYNTAX: 'SYNTAX',
    METADATA: 'METADATA',
    RUNTIME: 'RUNTIME',
    UPSTREAM: 'UPSTREAM',
    ASSET: 'ASSET'
} as const;

export type ErrorCategoryEnum = typeof ErrorCategoryEnum[keyof typeof ErrorCategoryEnum];
export const ErrorTypeEnum = {
    SYNTAXERROR: 'SYNTAX_ERROR',
    MAXDURATIONREQUIRED: 'MAX_DURATION_REQUIRED',
    MAXDURATIONPROHIBITED: 'MAX_DURATION_PROHIBITED',
    METADATAERROR: 'METADATA_ERROR',
    DATASPECERROR: 'DATA_SPEC_ERROR',
    RUNTIMEERROR: 'RUNTIME_ERROR',
    INCOMPATIBLEUNITS: 'INCOMPATIBLE_UNITS',
    CONTINUOUSREQUIRED: 'CONTINUOUS_REQUIRED',
    PROPERTYERROR: 'PROPERTY_ERROR',
    LOCALLYCONSTANT: 'LOCALLY_CONSTANT',
    ILLEGALVALUE: 'ILLEGAL_VALUE',
    ILLEGALPARAMETER: 'ILLEGAL_PARAMETER',
    UPSTREAMERROR: 'UPSTREAM_ERROR',
    FUNCTIONNOTFOUNDERROR: 'FUNCTION_NOT_FOUND_ERROR'
} as const;

export type ErrorTypeEnum = typeof ErrorTypeEnum[keyof typeof ErrorTypeEnum];
